import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOrg } from '../contexts/OrgContext';

const ProtectedRoute = ({ 
  children, 
  requiredUserType, 
  requireOrg = false,
  currentUser,
  isLoading = false
}) => {
  const { org, isHydrating, setOrg } = useOrg();
  const location = useLocation();

  // Infer org from URL on first load and persist to context/localStorage
  React.useEffect(() => {
    if (!location.pathname.startsWith('/internal/')) return;
    const segments = location.pathname.split('/');
    const pathOrg = segments[2];
    if (!org && (pathOrg === 'bare' || pathOrg === 'epl')) {
      setOrg(pathOrg);
    }
  }, [location.pathname, org, setOrg]);

  // Show a minimal loading shell while session/org are restoring
  if (isLoading || isHydrating) {
    return <div style={{ padding: 16 }} />;
  }

  // Check authentication first
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  // Check user type if required
  if (requiredUserType && currentUser.userType !== requiredUserType) {
    return <Navigate to="/" replace />;
  }

  // Check org requirement for internal routes
  if (requireOrg && !org) {
    return <Navigate to="/org-select" replace />;
  }

  // Handle org mismatch for internal routes and infer org from URL
  if (requireOrg && location.pathname.startsWith('/internal/')) {
    const pathParts = location.pathname.split('/');
    const pathOrg = pathParts[2]; // /internal/[org]/...

    // If org not set but URL contains a valid org, allow it through
    if (!org && (pathOrg === 'bare' || pathOrg === 'epl')) {
      return children;
    }

    if (org && pathOrg && pathOrg !== org) {
      // Redirect to correct org dashboard if path doesn't match stored org
      return <Navigate to={`/internal/${org}/dashboard`} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
